import { ifNotEmpty } from '../../utils'

/**
 * intl message descriptor
 * @typedef {Object} messageDescriptor
 * @property {String} id
 * @property {String} message
 * @property {String} defaultMessage
 */

/**
 * messages dictionary
 * @typedef {Object.<string, string>} messages
 */

/**
 * reducer for messages
 *
 * @param {messages} state - reduced messages
 * @param {messageDescriptor} message - message descriptor
 * @return {messages} reduced messages by id
 */
const messagesReducer = (state, { id, message, defaultMessage }) => ({
  ...state,
  [id]: ifNotEmpty(message, defaultMessage)
})

/**
 * reduce array of message descriptors
 *
 * @param {messageDescriptor[]} messages - to reduce
 * @return {messages} mapped messages
 */
export function reduceMessages(messages) {
  return messages.reduce(messagesReducer, {})
}
